/**
 * SelectField - Reusable select dropdown component
 * Uses Tailwind utilities for layout, DaisyUI for input styling
 */
/// <reference lib="dom" />

interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  disabled?: boolean;
  hint?: string;
}

export const SelectField = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  hint,
}: SelectFieldProps) => {
  const handleChange = (e: Event) => {
    onChange((e.target as HTMLSelectElement).value);
  };

  return (
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">{label}</label>
      <select
        class="select select-bordered w-full"
        value={value}
        onChange={handleChange}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {hint && <span class="text-xs opacity-60">{hint}</span>}
    </div>
  );
};
